import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import { nextStep, ifloorplanStateAdd } from '../redux/actions/actions';
import { updateNewPlan } from '../serverRequests/requests';
import MediaTable from './mediaTable';

const Media = (props) => {
    const [media, setMedia] = useState("");
    const [label, setLabel] = useState("");
    const ifloorplanObj = props.ifloorplanNowState;

    const Save = () => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        if(media != "" && label != ""){
            let type = "";
            try {
                const url = new URL(media);
                if (url.hostname == "youtube.com" || url.hostname == "www.youtube.com" || url.hostname == "youtu.be" ){
                    type = "youtubeVideo";
                } else if(url.hostname == "vimeo.com" || url.hostname == "www.vimeo.com" ) {
                    type = "vimeoVideo";
                } else {
                    type= "walk";
                }
            } catch (e) {
                return 1;
            }

            const new_media = {
                index: newState.media.length,
                type: type,
                url: media,
                label: label
            }
            newState.media.push(new_media);
            updateNewPlan(newState)
                .then((data)=>{
                    props.setAnimation(animationSaved=>animationSaved+1);
                    props.ifloorplanStateAdd(data[0]); //update state ifloorplan
                    props.nextStep("cams position", "_");
                })
        }
    }

    useEffect(() => {
        if(props.setShowTools)
            props.setShowTools(true);
    }, [])

    return(
        <div className="video">
            <div className="video_title">
                <div className="first_title"><h3>Add external media such as a video or 360 walk through</h3></div>
                <div className="second_title"><h4>The viewer will access this media by a navigation tab.</h4></div>
            </div>
            <div className="video_inputs">
                <div className="inputs">
                    <label htmlFor="video">URL for the video (YouTube, Vimeo) or 360 walk through (Matterport)</label>
                    <input type="text" onChange={event => {
                        setMedia(event.target.value);
                    }} id="video" placeholder="https://youtu.be"/>
                </div>
                <div className="inputs">
                    <label htmlFor="label">Label for a navigation tab</label>
                    <input type="text" id="label" onChange={event => {
                        setLabel(event.target.value);
                    }} placeholder="Property video"/>
                </div>
                <div className="button_group">
                    <button className="cancel" onClick={()=>props.nextStep("cams position", "_")}>Cancel</button>
                    <button className="save" onClick={Save}>Save</button>
                </div>
            </div>
            {/* <div className="video_comment">
                <h3>
                    As a symbol - Video plays smaller with floor plan still visible.
                    Viewer has option to expand to full window width
                </h3>
            </div> */}
            <div className='mediatable'>
                {ifloorplanObj.media.length > 0 ?
                    <MediaTable
                    save={Save}
                    plan={ifloorplanObj}
                    nextStep={props.nextStep}
                    setAnimation={props.setAnimation}
                    ifloorplanStateAdd={props.ifloorplanStateAdd} /> : ''
                }
            </div>
        </div>
    )
}



const putState = (state) => {
    return {
        ifloorplanNowState: state.ifloorplanNowState,
    }
}
const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
    }
}
export default connect(putState, putActions)(Media);